import React from "react"
import {Route, Routes} from "react-router-dom"
import {Home as LandingHome} from "../../pages/Landing"
import {Features} from "../../pages/Landing/Features"
import {Roadmap} from "../../pages/Landing/Roadmap"

export const LandingRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingHome/>}/>
      <Route path="/features" element={<Features/>}/>
      <Route path="/roadmap" element={<Roadmap/>}/>
    </Routes>
  )
}
